/** @prettier */
import {
  mergeConfigurations,
  useBaseSignUpConfiguration,
} from '@xanadu/ui-shared/components/SignUp/configuration';

const useSignUpConfiguration = (overrides = {}) => {
  const baseConfig = useBaseSignUpConfiguration();

  const { stepMapping: stepMappingOverride, stepReplace = false, ...rest } = overrides;

  const stepMapping = stepMappingOverride
    ? { ...(!stepReplace ? baseConfig.stepMapping : {}), ...stepMappingOverride }
    : undefined;

  return mergeConfigurations(baseConfig, {
    ...rest,
    ...(stepMapping ? { stepMapping } : {}),
  });
};

export default useSignUpConfiguration;
